<!-- eslint-disable max-len -->
<template>
  <div>
    <v-alert :value="alert()" dismissible :type="alertType()">
      {{ alertMessage }}
    </v-alert>
    <v-dialog v-model="pdf_dialog">
      <v-toolbar class="py-0 subheading" dark color="primary">
        AVISO
        <v-spacer></v-spacer>
        <v-btn flat icon @click="pdf_dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <embed class="hidden-md-and-down" :src="pdf_file" type="application/pdf" width="100%" height="700px" />
    </v-dialog>
    <v-dialog v-model="send_dialog" persistent width="700" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          ENVIAR AVISO
          <v-spacer></v-spacer>
          <v-btn flat icon @click="send_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md fluid>
          <v-flex xs12>
            <v-combobox v-model="send_option" :items="send_options" label="Seleccione destinatarios"></v-combobox>
          </v-flex>
          <v-flex xs12 v-if="send_option === 'Subcondominio'">
            <v-combobox v-model="subcondominio" :items="subcondominios" item-text="nombre" item-value="id" label="Seleccione subcondominio"></v-combobox>
          </v-flex>
          <v-flex xs12 sm12 md12 class="mt-1">
            <div class="text-xs-center">
              <v-btn color="primary" v-if="send_button" @click="send_aviso" class="mt-2" :disabled="send_disabled">
                ENVIAR
              </v-btn>
              <v-progress-circular v-else :indeterminate="true" color="primary">
              </v-progress-circular>
            </div>
          </v-flex>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogReporte" persistent width="700" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          AGREGAR AVISO
          <v-spacer></v-spacer>
          <v-btn flat icon @click="dialogReporte = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md fluid>
          <v-form ref="form" name="avisoForm" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field v-model="titulo_aviso" label="Título" single-line required :rules="title_rules"
                  hide-details></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <p v-if="file_error" style="color:red;">{{ file_error }}</p>
                <p>* se requiere un archivo PDF no mayor a 3MB</p>
                <input required type="file" v-show="true" ref="inputUpload" accept="application/pdf" id="aviso_file"
                  color="primary" name="aviso_file">
              </v-flex>
              <v-flex xs12 sm12 md12 class="mt-1">
                <div class="text-xs-center">
                  <v-btn color="primary" v-if="send_button" @click="validate" class="mt-2">
                    AGREGAR
                  </v-btn>
                  <v-progress-circular v-else :indeterminate="true" color="primary">
                  </v-progress-circular>
                </div>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
    <v-card-title>
      <v-btn color="primary" @click="dialogReporte = true">
        AGREGAR AVISO
      </v-btn>
      <v-spacer />
      <!--
      <v-text-field v-model="presearch" append-icon="search" label="Buscar" single-line hide-details />
      -->
    </v-card-title>
    <v-data-table :headers="headers" :items="rowItems" :pagination.sync="pagination" :total-items="totalItems"
      :loading="loading" :rows-per-page-items="[5, 10, 25, 50]" disable-initial-sort>
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-left px-2">
            {{ props.item.aviso_id }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.titulo }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.creado }}
          </td>
          <td class="text-xs-left px-2">
            <v-btn color="primary" @click="show_pdf(props.item.adjunto)" class="mt-2">
              VER ARCHIVO
            </v-btn>
            <v-btn color="primary" @click="show_send_dialog(props.item.aviso_id)" class="mt-2"
              :disabled="props.item.enviado">
              ENVIAR
            </v-btn>
            <v-btn color="primary" @click.prevent="show_details(props.item.aviso_id)" class="mt-2"
              v-if="props.item.enviado">
              DETALLES ENVIO
            </v-btn>
            <v-btn color="primary"
                   @click="delete_aviso(props.item.aviso_id)" class="mt-2">
                  ELIMINAR
                </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
  
  <script>

// eslint-disable-next-line camelcase

export default {
  data: () => ({
    pdf_dialog: false,
    pdf_file: null,
    selected_aviso: null,
    send_dialog: false,
    aviso_form: {},
    subcondominios: [],
    subcondominio: null,
    send_option: null,
    send_options: ['Condominio Maestro', 'Subcondominio'],
    send_button: true,
    send_disabled: true,
    file_error: null,
    title_rules: [v => !!v || 'Campo Requerido'],
    titulo_aviso: '',
    aviso_file: [],
    valid: false,
    presearch: '',
    searchTimer: null,
    search: '',
    menu_fecha_desde: false,
    fecha_desde: null,
    menu_fecha_hasta: false,
    fecha_hasta: null,
    dialogReporte: false,
    rowItems: [],
    pagination: {},
    totalItems: 0,
    loading: false,
    headers: [
      {
        text: 'ID', value: 'aviso_id', sortable: false,
      },
      {
        text: 'TÍTULO', value: 'titulo', sortable: false,
      },
      {
        text: 'CREADO', value: 'creado', sortable: false,
      },
      {
        text: 'ACCIONES', value: 'acciones', sortable: false,
      },
    ],
  }),
  created() {
    this.getSubcondominios();
  },
  methods: {
    show_details(avisoId) {
      this.$router.push({ name: 'detalles_aviso', params: { id: avisoId } });
    },
    alertType() {
      return this.$store.getters['avisos/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['avisos/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['avisos/alertContainer'];
    },
    show_send_dialog(avisoId) {
      this.selected_aviso = avisoId;
      this.send_dialog = true;
    },
    getSubcondominios() {
      this.$store.dispatch('avisos/listarSubcondominiosAvisos').then((data) => {
        this.subcondominios = data.subcondominios;
      });
    },
    delete_aviso(avisoId) {
      this.$store.dispatch('avisos/deleteAviso', avisoId).then(() => {
        this.fetchAvisos();
      });
    },
    send_aviso() {
      this.$nextTick(() => {
        this.$store.commit('avisos/clearAlertDialog');
      });
      const payload = { aviso_id: this.selected_aviso };
      this.send_disabled = true;
      this.send_button = false;
      if (this.send_option === 'Subcondominio') {
        payload.subcondominios = [this.subcondominio.id];
      } else {
        payload.subcondominio_maestro = true;
      }
      this.$store.dispatch('avisos/notifyAviso', payload).then(() => {
        this.clear_send_form();
        this.fetchAvisos();
      }).catch(() => {
        this.clear_send_form();
      });
    },
    show_pdf(avisoFile) {
      this.$store.dispatch('avisos/obtenerArchivoAviso', avisoFile).then((data) => {
        this.pdf_file = URL.createObjectURL(data);
        this.pdf_dialog = true;
      });
    },
    clear_send_form() {
      this.send_dialog = false;
      this.selected_aviso = null;
      this.send_button = true;
      this.send_disabled = false;
      this.send_option = null;
      this.pisos = [];
      this.torre = null;
    },
    validate() {
      if (this.$refs.form.validate()) {
        if (this.$refs.inputUpload.files.length > 0) {
          if (this.$refs.inputUpload.files[0].size > 1024 * 1024 * 3) {
            this.file_error = 'el archivo no puede ser mayor a 3MB';
          } else {
            // const formdata = new FormData(document.forms.namedItem('avisoForm'));
            const formdata = new FormData();
            formdata.append('aviso_file', this.$refs.inputUpload.files[0]);
            formdata.append('titulo', this.titulo_aviso);
            this.send_button = false;
            this.$store.dispatch('avisos/createAviso', formdata).then(() => {
              this.file_error = null;
              this.titulo_aviso = '';
              this.send_button = true;
              this.dialogReporte = false;
              this.fetchAvisos();
            });
          }
        } else {
          this.file_error = 'Se requiere proporcionar un archivo PDF no mayor a 3MB';
        }
      }
    },
    fetchAvisos() {
      this.loading = true;
      const {
        sortBy, descending, page, rowsPerPage,
      } = this.pagination;

      const formdata = {
        page,
        per_page: rowsPerPage,
        search: this.search,
        order_by: sortBy,
        descending,
      };
      this.$store.dispatch('avisos/fetchAvisos', formdata)
        .then((data) => {
          this.totalItems = data.total;
          this.rowItems = data.avisos;
          this.loading = false;
        });
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    validate_form() {
      this.send_disabled = false;
    },
  },
  watch: {
    pagination: {
      handler() {
        this.fetchAvisos();
      },
      deep: true,
    },
    send_option: {
      handler() {
        this.validate_form();
      },
    },
    search() {
      this.fetchAvisos();
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
  },
};
</script>
<style scoped>

</style>
